/**
 * Trunnion AI - Quick Actions Bar
 * Row of action buttons for common dashboard operations.
 */

import { useNavigate } from 'react-router-dom';
import { Plus, GitBranch, Bot, Download, FileText } from 'lucide-react';
import { ROUTES } from '@/config/routes';

interface QuickAction {
  label: string;
  icons: [React.ComponentType<{ className?: string }>, React.ComponentType<{ className?: string }>];
  route: string;
}

const actions: QuickAction[] = [
  {
    label: 'New Workflow',
    icons: [Plus, GitBranch],
    route: ROUTES.WORKFLOW_NEW,
  },
  {
    label: 'Create Agent',
    icons: [Plus, Bot],
    route: ROUTES.AGENT_NEW,
  },
  {
    label: 'Export Audit',
    icons: [Download, FileText],
    route: ROUTES.AUDIT,
  },
];

export function QuickActions() {
  const navigate = useNavigate();

  return (
    <div className="flex items-center gap-3">
      {actions.map(({ label, icons: [Icon1, Icon2], route }) => (
        <button
          key={label}
          onClick={() => navigate(route)}
          className="flex items-center gap-2 rounded-lg border border-trunnion-slate-700 bg-trunnion-slate-800/50 px-4 py-2.5 text-sm font-medium text-trunnion-slate-300 transition-colors hover:border-trunnion-slate-600 hover:bg-trunnion-slate-800 hover:text-white"
        >
          <span className="flex items-center gap-1 text-trunnion-gold-500">
            <Icon1 className="h-3.5 w-3.5" />
            <Icon2 className="h-3.5 w-3.5" />
          </span>
          {label}
        </button>
      ))}
    </div>
  );
}
